import { axiosWithAuth, convertDateToISO, TIME_OFFSET_DAY_END } from "helpers";
import { NoteService } from "types";

export const agentOfficeNotesService: NoteService = {
	addNote,
	deleteNote,
	editNote,
	getNotes,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getNotes(companyId, { page, ...filters }) {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			creator_id: filters?.creator?.id,
			category: filters?.category?.value,
			from: convertDateToISO(filters?.dateNote?.[0]),
			to: convertDateToISO(filters?.dateNote?.[1], {
				addTime: TIME_OFFSET_DAY_END,
			}),
		},
		url: `${API_URL}/api/companies/${companyId}/notes`,
	});
}

function addNote(companyId, note) {
	return axiosWithAuth({
		method: "POST",
		data: note,
		url: `${API_URL}/api/companies/${companyId}/notes`,
	});
}

function editNote(companyId, note) {
	return axiosWithAuth({
		method: "PUT",
		data: note,
		url: `${API_URL}/api/companies/${companyId}/notes/${note.id}`,
	});
}

function deleteNote(companyId, note) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${API_URL}/api/companies/${companyId}/notes/${note.id}`,
	});
}
